import { InlineNotification } from '@carbon/react';
import { TitleChainValidatorErrorProps } from './types';

export const TitleChainValidatorError = ({
  error,
}: TitleChainValidatorErrorProps) => {
  const getErrorMessage = (): string => {
    if (typeof error === 'string') {
      return error;
    }
    if (error && typeof error === 'object') {
      if ('errors' in error) {
        return JSON.stringify(error.errors);
      }
      if ('message' in error && typeof error.message === 'string') {
        return error.message;
      }
    }
    return 'An unexpected error occurred';
  };

  const errorMessage = getErrorMessage();

  return (
    <InlineNotification
      kind="error"
      title="Error Occurred"
      subtitle={errorMessage}
      lowContrast
    />
  );
};
